import React from 'react'
import styled from '@emotion/styled'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { YouTube } from 'src/components/molecules/YouTube'
import { vwSize } from 'src/utils/vwCss'
// image
import h3l from 'src/images/top/h3-l.svg'
import h3r from 'src/images/top/h3-r.svg'

export const TopVideo: React.VFC = () => {

  return (
    <Container>
      <FadeDownWrap>
        <MovieTtl className={"g-h3"}>
          <H3Text>commmune紹介動画はこちら！</H3Text>
        </MovieTtl>
        <YouTube 
          caption="" 
          url="https://www.youtube.com/embed/GEjhwsdvDnk"/>
      </FadeDownWrap>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${Styles.color.primary[100]};
  padding: 0 ${vwSize(16, 'sp')}vw ${Styles.spacing[11]};
  margin: auto;
  gap: ${Styles.spacing[10]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 0 50px ${Styles.spacing[13]};
  }
`
const MovieTtl = styled.h3`
  text-align: center;
`
const H3Text = styled.div`
  text-align: center;
  display: inline-block;
  margin-bottom: ${vwSize(20, 'pc')}vw;
  position: relative;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-bottom: ${vwSize(20, 'sp')}vw;
  }

  &:before {
    content: "";
    background-image: url(${h3l});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: ${vwSize(20, 'pc')}vw;
    height: ${vwSize(20, 'pc')}vw;
    position: absolute;
    left: -2em;
    top: -1%;
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      width: ${vwSize(6, 'sp')}vw;
      height: ${vwSize(24, 'sp')}vw;
    }
  }
  &:after {
    content: "";
    background-image: url(${h3r});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: ${vwSize(20, 'pc')}vw;
    height: ${vwSize(20, 'pc')}vw;
    position: absolute;
    right: -2em;
    top: -1%;
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      width: ${vwSize(6, 'sp')}vw;
      height: ${vwSize(24, 'sp')}vw;
    }
  }
`

